import QuickApprovals from "../assets/svgIcons/shock.svg";
import CustomizedSolutions from "../assets/svgIcons/settings.svg";
import CurrencyDollar from "../assets/svgIcons/dollar.svg";
import Headphones from "../assets/svgIcons/headset.svg";

export interface WhyChooseUsFeature {
  icon: string;
  title: string;
  description: string;
}

export const whyChooseUsFeatures: WhyChooseUsFeature[] = [
  {
    icon: QuickApprovals,
    title: "Quick Approvals",
    description:
      "Get your loan approved in as little as 3 days with our streamlined digital process and minimal documentation.",
  },
  {
    icon: CustomizedSolutions,
    title: "Customized Solutions",
    description:
      "Tailored loan structures based on your course, institution, and financial situation with flexible repayment options.",
  },
  {
    icon: CurrencyDollar,
    title: "100% Financing",
    description:
      "Cover all education expenses including tuition, accommodation, travel, and study materials with no hidden charges.",
  },
  {
    icon: Headphones,
    title: "Expert Guidance",
    description:
      "Dedicated loan counselors to assist you throughout the application process and during your education journey.",
  },
];
